module.exports = __webpack_public_path__ + "media/assets/svgs/menu-f0029c77ea1c6e710f0e5d0909456106.svg";